<template>
	
	<div class="login">
		
		<div class="login__background">
			
			<div class="login__background-top">
				
			</div>
			
			<div class="login__background-bottom"></div>
			
		</div>
		
		<div class="login__form-outer">
			
			<div class="login__form-inner">
				
				<div class="card card--shadow login__card" v-loading="loggingIn">
					
					<div class="login__logo-container">
						<img class="login__logo" src="@/assets/logo.png">
					</div>
					
					<el-form class="login__form" ref="logInForm" status-icon>
						
						<el-form-item label="Email Address">
							<el-input v-model="email" type="email" autocomplete="off"></el-input>
						</el-form-item>
						
						<el-form-item label="Password">
							<el-input v-model="password" type="password" autocomplete="off"></el-input>
						</el-form-item>
						
						<!--<el-button type="text" style="float: left;" @click.prevent="onClickForgotPassword">Forgot Password?</el-button>
						-->
						
						<el-button class="login__button" type="primary" @click.prevent="onClickLogIn">Log In</el-button>
						
					</el-form>
					
				</div>
				
				<p class="login__copyright">Copyright 2019 Verto Group. All rights reserved.</p>
				
			</div>
			
		</div>
		
	</div>
	
</template>

<script>
	
	export default {
		
		name: "LogIn",
		
		data() {
			
			return {
				
				loading: false,
				
				email: "",
				password: "",
				
			}
			
		},
		
		computed: {
			
			loggingIn() {
				return this.loading || this.$auth.check();
			},
			
		},
		
		methods: {
			
			onClickLogIn() {
				
				this.loading = true;
				
				setTimeout(() => {
					this.$auth.login({
						params: { email: this.email, password: this.password }, 
						rememberMe: true,
						fetchUser: true,
						redirect: "dashboard",
						success: (e) => {
							this.axios.get("startup").then((r) => {
								this.$store.commit("setApiData", { key: "clients", data: r.data.clients });
								this.$store.commit("setApiData", { key: "projects", data: r.data.projects });
								this.$store.commit("setApiData", { key: "users", data: r.data.users });
								this.$store.commit("loggedIn", this.$auth.check());
							});
						},
						error: (e) => {
							this.loading = false;
							this.$message.error({
								message: "Invalid login credentials. Please try again.",
								duration: 5000,
							});
						},
					});
				}, 1000);
				
			},
			
			onClickForgotPassword() {
				
			},
			
		},
		
	}
	
</script>

<style lang="scss">
	
	
	
</style>



// WEBPACK FOOTER //
// src/components/LogIn.vue